/* eslint-disable */
import { useRef } from "react";
import { C, styles } from "./tokens";

// ─── DATA IMPORT / EXPORT ──────────────────────────────────────────────────────
function DataPanel({ clients, setClients }) {
  const fileRef = useRef();

  const exportData = () => {
    const blob = new Blob([JSON.stringify(clients, null, 2)], { type: "application/json" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob);
    a.download = "rmd_data.json"; a.click();
  };

  const importData = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const data = JSON.parse(ev.target.result);
        setClients(data);
      } catch { alert("Invalid JSON file."); }
    };
    reader.readAsText(file);
    e.target.value = "";
  };

  return (
    <div style={{ padding: "16px 24px", borderTop: `1px solid ${C.borderLight}`, background: C.surface }}>
      <div style={{ fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.05em", color: C.textMuted, marginBottom: 8 }}>Data</div>
      <div style={{ display: "flex", gap: 8 }}>
        <button style={{ ...styles.btnSecondary, fontSize: 11, padding: "6px 12px" }} onClick={exportData}>⬇ Export JSON</button>
        <button style={{ ...styles.btnSecondary, fontSize: 11, padding: "6px 12px" }} onClick={() => fileRef.current.click()}>⬆ Import JSON</button>
        <input ref={fileRef} type="file" accept=".json" style={{ display: "none" }} onChange={importData} />
      </div>
    </div>
  );
}


export { DataPanel };
